import React from "react"
import { Link } from "gatsby"

const DorotButton = ({
  type = "rounded-full",
  bgColor = "dorot-purple",
  text,
  textColor = "text-white",
  font = "gelica",
  fontSize = "_1820",
  fontWeight = "semibold",
  link = "#",
  beforeIcon = null, // SVG icon
  afterIcon = null, // SVG icon
  width = "w-full",
  padding = "py-3.5 px-12.5",
}) => {
  return (
    <Link to={link} className="flex justify-center items-center">
      <button
        className={`${width} flex flex-row justify-center items-center bg-${bgColor} ${type} ${textColor} 1024:text-_1820 text-${fontSize} font-${font} font-${fontWeight} shadow-dorot_button ${padding}`}
      >
        {beforeIcon && <span className="mr-1">{beforeIcon}</span>}
        {text}
        {afterIcon && <span className="ml-1">{afterIcon}</span>}
      </button>
    </Link>
  )
}

export default DorotButton
